module.exports = __webpack_public_path__ + "static/img/girl.d1530f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/girl.png
// module id = zS10
// module chunks = 410